import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
  {
    variants: {
      variant: {
        // Классические «пилюли» (rounded-full, semibold) — семантические лейблы.
        default:
          'rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold bg-primary text-primary-foreground',
        secondary:
          'rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold bg-secondary text-secondary-foreground',
        destructive:
          'rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold bg-destructive text-destructive-foreground',
        // Статусы модерации: warning — на проверке, success — одобрено/опубликовано.
        warning:
          'rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold bg-warning text-warning-foreground',
        success:
          'rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold bg-success text-success-foreground',
        outline: 'rounded-full border px-2.5 py-0.5 text-xs font-semibold text-foreground',
        // Брендовый акцент-лейбл (скидка, промо): мягкая фирменная заливка.
        brand:
          'rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold bg-brand/30 text-brand',
        // Маркер-канон: «скоро», роли (Admin), мелкие пометки. Приглушённая пилюля, в
        // одном ряду с остальными скруглёнными элементами системы.
        // leading-none — иначе размер наследует line-height родителя → разная высота.
        neutral: 'rounded-full px-2 py-1 text-xs leading-none text-muted-foreground bg-muted',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
